import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../services/authService';

// Async thunk — ยิง API แค่ครั้งเดียว ผลลัพธ์เก็บใน Redux
export const fetchUserProfile = createAsyncThunk(
  'user/fetchUserProfile',
  async (_, { getState, rejectWithValue }) => {
    try {
      // ถ้า profile โหลดแล้ว ไม่ต้องยิง API ซ้ำ
      const state = getState();
      if (state.user?.loaded && state.user?.profile) {
        return state.user.profile;
      }
      const data = await authService.getUserProfile();
      return data;
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to fetch profile');
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    profile: null,
    loading: false,
    loaded: false,
    error: null,
  },
  reducers: {
    clearUserProfile: (state) => {
      state.profile = null;
      state.loading = false;
      state.loaded = false;
      state.error = null;
    },
    setUserProfile: (state, action) => {
      state.profile = action.payload;
      state.loaded = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUserProfile, setUserProfile } = userSlice.actions;
export default userSlice.reducer;
